/* iYos — filtrado, orden y conteos de la página de colección.
   Trabaja sobre los data-* que iyos-card-product.liquid deja en cada tarjeta,
   así que no depende de metacampos ni de la app Search & Discovery. */

(function () {
  'use strict';

  var GROUPS = [
    { key: 'tipo', label: 'Tipo' },
    { key: 'year', label: 'Año' },
    { key: 'size', label: 'Tamaño' },
    { key: 'ram', label: 'Memoria RAM' },
    { key: 'ssd', label: 'Almacenamiento' },
  ];

  var VISIBLE_BEFORE_MORE = 5;

  function init(root) {
    var grid = root.querySelector('[data-iyos-grid]');
    var facetHost = root.querySelector('[data-iyos-facet-groups]');
    if (!grid || !facetHost) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.iyos-card'));
    if (!cards.length) return;

    var countEl = root.querySelector('[data-iyos-count]');
    var wordEl = root.querySelector('[data-iyos-count-word]');
    var emptyEl = root.querySelector('[data-iyos-empty]');
    var clearBtn = root.querySelector('[data-iyos-clear]');
    var sortEl = root.querySelector('[data-iyos-sort]');

    var panel = root.querySelector('[data-iyos-facets]');
    var openBtn = root.querySelector('[data-iyos-facets-open]');
    var scrim = root.querySelector('[data-iyos-facets-scrim]');
    var badge = root.querySelector('[data-iyos-facets-badge]');
    var sheetCounts = root.querySelectorAll('[data-iyos-sheet-count]');

    /* La liquidación no es un grupo más: es un sí/no, así que vive aparte y
       se dibuja arriba de todo. */
    var hayLiq = cards.some(function (c) { return c.dataset.liq === '1'; });
    var liqLabel = root.dataset.iyosLiqLabel || 'Liquidación';
    var soloLiq = false;

    var selected = {};
    var expanded = {};
    GROUPS.forEach(function (g) {
      selected[g.key] = new Set();
      expanded[g.key] = false;
    });

    /* Valores presentes en el catálogo, en el orden que corresponde a cada
       grupo: los años de más nuevo a más viejo, los tamaños y capacidades
       por magnitud, el resto alfabético. */
    function valuesFor(key) {
      var seen = Object.create(null);
      cards.forEach(function (c) {
        var v = c.dataset[key];
        if (v) seen[v] = true;
      });
      var list = Object.keys(seen);
      if (key === 'year') return list.sort(function (a, b) { return Number(b) - Number(a); });
      if (key === 'size' || key === 'ram' || key === 'ssd') {
        return list.sort(function (a, b) { return magnitude(a) - magnitude(b); });
      }
      return list.sort(function (a, b) { return a.localeCompare(b, 'es'); });
    }

    function magnitude(v) {
      var n = parseFloat(v) || 0;
      return /TB/i.test(v) ? n * 1024 : n;
    }

    /* Un producto pasa el filtro si, en cada grupo, o no hay nada marcado
       o su valor está entre los marcados. */
    function matches(card, skipKey) {
      if (soloLiq && card.dataset.liq !== '1') return false;
      return GROUPS.every(function (g) {
        if (g.key === skipKey) return true;
        var sel = selected[g.key];
        return sel.size === 0 || sel.has(card.dataset[g.key]);
      });
    }

    /* El conteo de una opción ignora su propio grupo: así "MacBook Pro (5)"
       sigue siendo cierto mientras se marcan otras opciones del mismo grupo. */
    function countFor(key, value) {
      var n = 0;
      for (var i = 0; i < cards.length; i++) {
        if (cards[i].dataset[key] === value && matches(cards[i], key)) n++;
      }
      return n;
    }

    function anySelected() {
      if (soloLiq) return true;
      return GROUPS.some(function (g) { return selected[g.key].size > 0; });
    }

    /* Cuántos quedarían al marcarlo: se ignora el propio filtro, igual que en
       los conteos de los demás grupos. */
    function countLiq() {
      return cards.filter(function (c) {
        if (c.dataset.liq !== '1') return false;
        return GROUPS.every(function (g) {
          var sel = selected[g.key];
          return sel.size === 0 || sel.has(c.dataset[g.key]);
        });
      }).length;
    }

    function renderFacets() {
      var html = '';

      if (hayLiq) {
        html +=
          '<div class="iyos-facet iyos-facet--liq"><div class="iyos-facet__list">' +
          '<label class="iyos-opt">' +
          '<input type="checkbox" data-liq' + (soloLiq ? ' checked' : '') + '>' +
          '<span class="iyos-opt__v">' + escapeHtml(liqLabel) + '</span>' +
          '<span class="iyos-opt__n">(' + countLiq() + ')</span>' +
          '</label></div></div>';
      }

      GROUPS.forEach(function (g) {
        /* Dinámico: una opción que ya no daría ningún resultado no se muestra,
           salvo que esté marcada — si no, no habría cómo desmarcarla. */
        var values = valuesFor(g.key)
          .map(function (v) {
            return { v: v, n: countFor(g.key, v), on: selected[g.key].has(v) };
          })
          .filter(function (o) { return o.n > 0 || o.on; });

        // Un solo valor no es un filtro; con algo marcado el grupo se queda.
        if (values.length < 2 && selected[g.key].size === 0) return;

        var isLong = values.length > VISIBLE_BEFORE_MORE;
        var shown = isLong && !expanded[g.key] ? values.slice(0, VISIBLE_BEFORE_MORE) : values;

        html += '<div class="iyos-facet" data-open="true">';
        html += '<button class="iyos-facet__h" type="button" data-toggle="' + g.key + '" aria-expanded="true">';
        html += '<span>' + g.label + '</span>';
        html += '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9.5l6 6 6-6"/></svg>';
        html += '</button><div class="iyos-facet__list">';

        shown.forEach(function (o) {
          html +=
            '<label class="iyos-opt' + (o.n === 0 ? ' is-off' : '') + '">' +
            '<input type="checkbox" data-k="' + g.key + '" value="' + escapeAttr(o.v) + '"' + (o.on ? ' checked' : '') + '>' +
            '<span class="iyos-opt__v">' + escapeHtml(o.v) + '</span>' +
            '<span class="iyos-opt__n">(' + o.n + ')</span>' +
            '</label>';
        });

        if (isLong) {
          html +=
            '<button class="iyos-more" type="button" data-more="' + g.key + '">' +
            (expanded[g.key] ? 'Ver menos' : 'Ver más') +
            '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="rotate:' +
            (expanded[g.key] ? '180deg' : '0deg') +
            '"><path d="M6 9.5l6 6 6-6"/></svg></button>';
        }

        html += '</div></div>';
      });

      facetHost.innerHTML = html;
      if (clearBtn) clearBtn.hidden = !anySelected();

      if (badge) {
        var marcados = GROUPS.reduce(function (n, g) { return n + selected[g.key].size; }, 0);
        if (soloLiq) marcados += 1;
        badge.textContent = marcados;
        badge.hidden = marcados === 0;
      }
    }

    function applyFilters() {
      var visible = 0;
      cards.forEach(function (c) {
        var ok = matches(c, null);
        c.hidden = !ok;
        if (ok) visible++;
      });

      if (countEl) countEl.textContent = visible;
      if (wordEl) wordEl.textContent = visible === 1 ? 'producto disponible' : 'productos disponibles';
      if (emptyEl) emptyEl.hidden = visible !== 0;
      grid.hidden = visible === 0;

      // El panel de móvil tapa la grilla, así que lleva su propio contador.
      sheetCounts.forEach(function (el) { el.textContent = visible; });
    }

    /* ── Panel de filtros en móvil ─────────────────────────────────────── */
    function abrirPanel(abierto) {
      if (!panel || !openBtn) return;
      panel.dataset.abierto = String(abierto);
      openBtn.setAttribute('aria-expanded', String(abierto));
      if (scrim) scrim.hidden = !abierto;
      document.documentElement.style.overflow = abierto ? 'hidden' : '';
      if (abierto) panel.scrollTop = 0;
    }

    if (openBtn) {
      openBtn.addEventListener('click', function () {
        abrirPanel(panel.dataset.abierto !== 'true');
      });
    }

    if (scrim) scrim.addEventListener('click', function () { abrirPanel(false); });

    root.querySelectorAll('[data-iyos-facets-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { abrirPanel(false); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel && panel.dataset.abierto === 'true') abrirPanel(false);
    });

    // Al volver a escritorio el panel deja de tener sentido: no dejar el
    // scroll de la página bloqueado.
    window.matchMedia('(min-width: 990px)').addEventListener('change', function (e) {
      if (e.matches) abrirPanel(false);
    });

    function applySort() {
      var mode = sortEl ? sortEl.value : 'price-asc';
      var sorted = cards.slice().sort(function (a, b) {
        switch (mode) {
          case 'price-desc':
            return num(b, 'price') - num(a, 'price');
          case 'year-desc':
            return num(b, 'year') - num(a, 'year') || num(a, 'price') - num(b, 'price');
          case 'name-asc':
            return a.dataset.name.localeCompare(b.dataset.name, 'es');
          default:
            return num(a, 'price') - num(b, 'price');
        }
      });
      sorted.forEach(function (c) { grid.appendChild(c); });
    }

    function num(el, key) {
      return parseInt(el.dataset[key], 10) || 0;
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }

    function escapeAttr(s) {
      return escapeHtml(s).replace(/'/g, '&#39;');
    }

    facetHost.addEventListener('change', function (e) {
      var liq = e.target.closest('input[data-liq]');
      if (liq) {
        soloLiq = liq.checked;
        renderFacets();
        applyFilters();
        return;
      }

      var input = e.target.closest('input[data-k]');
      if (!input) return;
      var sel = selected[input.dataset.k];
      if (input.checked) sel.add(input.value);
      else sel.delete(input.value);
      renderFacets();
      applyFilters();
    });

    facetHost.addEventListener('click', function (e) {
      var more = e.target.closest('[data-more]');
      if (more) {
        expanded[more.dataset.more] = !expanded[more.dataset.more];
        renderFacets();
        return;
      }
      var head = e.target.closest('[data-toggle]');
      if (head) {
        var box = head.closest('.iyos-facet');
        var open = box.dataset.open === 'true';
        box.dataset.open = open ? 'false' : 'true';
        head.setAttribute('aria-expanded', String(!open));
      }
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        GROUPS.forEach(function (g) { selected[g.key].clear(); });
        soloLiq = false;
        renderFacets();
        applyFilters();
      });
    }

    if (sortEl) {
      sortEl.addEventListener('change', function () { applySort(); });
    }

    renderFacets();
    applySort();
    applyFilters();
  }

  function boot() {
    document.querySelectorAll('.iyos-collection').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // El editor de temas vuelve a inyectar la sección al editarla.
  document.addEventListener('shopify:section:load', boot);
})();
